import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'

import i18n from '@/i18n/i18n'
import ElementUI from 'element-ui'

import './utils/rem'

import '@/assets/css/font.css'
import '@/assets/css/reset.css'
import '@/assets/fonts/Roboto-Bold.css'
import '@/assets/fonts/Roboto Slab Regular.css'
import '@/assets/css/common1.css'
// import '@/assets/css/animate-common.css'
import '@/directive/full-height.js'
import '@/directive/focus.js'
import '@/directive/header.js'
// import '@/directive/banner.js'
import '@/directive/number.js'
import '@/directive/show-add-class.js'
import '@/directive/swiper.js'

import uuid from 'uuid/v1'
import common from '@/utils/common'

import 'element-ui/lib/theme-chalk/index.css';
import {
  Loading,
  Message,
  Tabs,
  TabPane,
  Carousel,
  CarouselItem,
} from 'element-ui';

import { getRequest, postRequest, uploadFileRequest, postJsonRequest } from "@/utils/axios"

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)  //当切换 locale 的时候，t()函数会根据传入的key值去locale指定的语言包中找响应的值

})


Vue.config.productionTip = false

Vue.use(Loading.directive);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$get = getRequest
Vue.prototype.$post = postRequest
Vue.prototype.$postJson = postJsonRequest
Vue.prototype.$ = common
Vue.prototype.$upload = uploadFileRequest
Vue.prototype.$uuid = uuid
Vue.prototype.$Message = Message
new Vue({
  render: h => h(App),
  router,
  store,
  i18n,// 挂载
  created () {

    this.$store.commit("getUser");
    this.$store.dispatch("checkUser");

  }
}).$mount('#app');

// 登录权限验证
// router.beforeEach((to, from, next) => {
// 	if (to.matched.some(record => record.meta.requiresAuth)) {
// 		let role = to.matched.find(item => item.meta.requiresAuth).meta.role;
// 		if (store.state.user == null || (store.state.user && store.state.user.role != role)) {
// 			next({
// 				path: '/login',
// 				query: {
// 					redirect: to.fullPath
// 				}
// 			})
// 		} else {
// 			next()  确保一定要调用 next()
// 		}
// 	} else {
// 		next()  确保一定要调用 next()
// 	}
// })
